/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Toast, Dialog, Tabs, Swiper, SwiperRef, CalendarPicker, Divider, PullToRefresh, InfiniteScroll } from 'antd-mobile'
import { useEffect, useRef, useState } from 'react'
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import format from 'date-fns/format'
// import { getMemberManagerList } from '@api/agile.api';
import './index.css'
import NoContentCion from './img/no-content.png'
import { CameraRpApi } from '@api/camera-rp.api'
import useLoadMore from 'hooks/useLoadMore'
enum AcceptStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  REJECTED = 'rejected'
}

const ACTION_STYLE = {
  CANCEL: {
    color: "var(--adm-color-text)",
    fontSize: '16px'
  },
  CONFIRM: {
    color: 'var(--adm-color-primary)',
    fontSize: '16px'
  }
}
export default function MyDispatch(props: any) {
  const [dpStatus, setDpStatus] = useState<any>()
  const swiperRef = useRef<SwiperRef>(null);
  const [activeStatus, setActiveStatus] = useState();
  const tabItems = [
    { key: AcceptStatus.PENDING, title: "待确认", component: DispatchList({ dpStatus, activeStatus, type: AcceptStatus.PENDING }) },
    { key: AcceptStatus.CONFIRMED, title: "已接受", component: DispatchList({ dpStatus, activeStatus, type: AcceptStatus.CONFIRMED }) },
    { key: AcceptStatus.REJECTED, title: "已拒绝", component: DispatchList({ dpStatus, activeStatus, type: AcceptStatus.REJECTED }) },
  ];

  useEffect(() => {
    const query = new URLSearchParams(props.location.search);
    CameraRpApi.getDispatchStatus({ id: query.get('id') as string }).then(res => {
      if (res) {
        setDpStatus(res.data)
        onChangeTab(res.data.acceptStatus)
      } else {
        setDpStatus({
          companyId: query.get('companyId'),
          faceEntityId: query.get('faceEntityId'),
        })
        onChangeTab(AcceptStatus.PENDING)
      }
      const themeColor = document.querySelector('meta[name="theme-color"]');
      // 设置默认主题色
      themeColor?.setAttribute('content', '#fff');
      document.title = res.data?.faceInfo?.name + '的派工信息'
    })
  }, [props.location.search])

  const onChangeTab = (key: any) => {
    const index = tabItems.findIndex((item: any) => item.key === key);
    setActiveStatus(key);
    swiperRef.current?.swipeTo(index);
  }
  if (!activeStatus) return <></>
  return (
    <div className='page-wrapper'>
      <div style={{
        zIndex: 1000,
        position: 'fixed',
        top: 0,
        width: '100%',
        background: '#fff'
      }}>
        <Tabs
          activeKey={activeStatus}
          activeLineMode={'fixed'}
          onChange={onChangeTab}
        >
          {tabItems.map((item: any) => (
            <Tabs.Tab style={{ fontWeight: 'bolder' }} title={item.title} key={item.key} />
          ))}
        </Tabs>
      </div>
      <Swiper
        style={{
          position: 'fixed',
          top: 44,
        }}
        direction="horizontal"
        indicator={() => null}
        ref={swiperRef}
        defaultIndex={tabItems.findIndex((item: any) => item.key === activeStatus)}
        onIndexChange={(index) => {
          setActiveStatus(tabItems[index].key)
        }}
      >
        {tabItems.map(it => (
          <Swiper.Item
            style={{
              height: 'calc(100vh - 44px)',
              overflowY: 'auto'
            }} key={it.key}>
            {it.component}
          </Swiper.Item>
        ))}
      </Swiper>
    </div>
  )
}

const getDuration = (startTime: any, endTime: any) => {
  return differenceInCalendarDays(new Date(endTime || ''), new Date(startTime || '')) + 1
}
const DispatchList = ({ dpStatus, activeStatus, type }: any) => {
  // const [projectManager, setManager] = useState<{ name?: string, mobile?: string }>({})
  const [rest, setRest] = useState<any>()

  const getRestTime = async () => {
    if (type !== AcceptStatus.PENDING) return
    const res: any = await CameraRpApi.getPersonDispatch({
      faceEntityId: dpStatus?.faceEntityId
    })
    setRest(res.data.rest)
  }

  const fetchData = async (pageNo: number, pageSize: number) => {
    const res: any = await CameraRpApi.getDpListByPerson({
      companyId: dpStatus.companyId,
      faceEntityId: dpStatus.faceEntityId,
      acceptStatus: type,
      topId: dpStatus?.id,
      pageNo,
      pageSize,
    });
    return res.data.items?.filter((x: any) => !x.actualStart && !x.acceptedAt);
  };
  const { data: dpList, loadMore, refresh: onRefresh, hasMore } = useLoadMore(fetchData);

  useEffect(() => {
    if (!dpStatus?.companyId || !dpStatus.faceEntityId) return
    activeStatus === type && onRefresh()
    if (dpStatus?.faceEntityId) {
      getRestTime()
    }
  }, [dpStatus])
  useEffect(() => {
    activeStatus === type && onRefresh()
  }, [activeStatus])
  return (
    <PullToRefresh
      onRefresh={async () => {
        await onRefresh()
        await getRestTime()
      }}
    >
      <div className='list-wrapper'>
        {type === AcceptStatus.PENDING && RenderRestTime({ dpStatus, rest, onRefresh: getRestTime })}
        {
          dpList.length > 0 ?
            <>
              {dpList.map((it: any) =>
                DispatchCard({
                  ...it,
                  dpStatus,
                  type, rest,
                  onRefresh: onRefresh
                }))}
              <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
              <div style={{ height: '120px' }}></div>
            </> : <div className='no-content'>
              <img src={NoContentCion} alt="" />
              <span>暂无数据</span>
            </div>
        }
      </div>
    </PullToRefresh>
  )
}

const DispatchCard = (props: any) => {
  const confirm = async (accepted: boolean) => {
    if (accepted) {
      let result: any
      let content: string = '确定要「接受」这个派工？'
      if (props?.rest) {
        result = await CameraRpApi.checkRestTimeClash({
          deadlineTime: props.plan.endTime,
          faceEntityId: props.dpStatus.faceEntityId,
          startTime: props?.rest?.startTime || undefined,
        })
        result?.data && !result?.data?.isPassed && (content = '计划工期与您的休息时间段有冲突，确定要接受吗？')
      }
      Dialog.show({
        content: CustomDialogContent({ content }),
        closeOnAction: true,
        actions: [
          [
            {
              key: 'cancel',
              text: '我再想想',
              style: ACTION_STYLE.CANCEL,
              danger: true,
              onClick: () => {

              }
            },
            {
              key: 'confirm',
              text: '确定接受',
              style: ACTION_STYLE.CONFIRM,
              onClick: async () => {
                await CameraRpApi.accept({
                  _id: props.id,
                  companyId: props.dpStatus.companyId,
                  faceEntityId: props.dpStatus.faceEntityId,
                  accepted
                })
                if (props) props.accepted = accepted
                // setDpList(dpList.filter(x => x._id !== props._id))
                Toast.show({ content: '操作成功', position: 'top' })
                props.onRefresh && props.onRefresh()
              }
            },
          ],
        ],
      })
    } else {
      Dialog.show({
        content: CustomDialogContent({ content: '确定要「拒绝」这个派工？' }),
        closeOnAction: true,
        actions: [
          [
            {
              key: 'cancel',
              text: '我再想想',
              style: ACTION_STYLE.CANCEL,
              danger: true,
              onClick: () => {

              }
            },
            {
              key: 'confirm',
              text: '确定拒绝',
              style: ACTION_STYLE.CONFIRM,
              onClick: async () => {
                await CameraRpApi.accept({
                  _id: props.id,
                  companyId: props.dpStatus.companyId,
                  faceEntityId: props.dpStatus.faceEntityId,
                  accepted
                })
                if (props) props.accepted = accepted
                // setDpList(dpList.filter(x => x._id !== props._id))
                Toast.show({ content: '操作成功', position: 'top' })
                props.onRefresh && props.onRefresh()
              }
            },
          ],
        ],
      })
    }

  }
  return <div className='item-wrapper' style={{
    border: props.isTop === 'Y' ? '1px solid var(--adm-color-primary)' : ''
  }}>
    {props?.type === AcceptStatus.CONFIRMED ? RowItem({
      name: '工期',
      desc: `${transferDate(props.plan.startTime)}-${transferDate(props.plan.endTime)} (${props.plan.days}天)`,
      specialDesc: ''
    }) :
      RowItem({ name: '工地', desc: props?.projectAddress })
    }
    {!!props.arrive?.status &&
      RowItem({
        name: '进场',
        desc: `${transferDate(props.arrive.time)} `,
        specialDesc: props.arrive.time ? `(${props.arrive.description})` : props.arrive.description,
        status: props.arrive.status
      })}
    {!!props.exit?.status &&
      RowItem({
        name: '退场',
        desc: `${transferDate(props.exit.time)} `,
        specialDesc: props.exit.time ? `(${props.exit.description})` : props.exit.description,
        status: props.exit.status,
        type: 'exit'
      })}
    {props?.type === AcceptStatus.CONFIRMED ?
      RowItem({ name: '工地', desc: props?.projectAddress })
      : RowItem({
        name: '工期',
        desc: `${transferDate(props.plan.startTime)}-${transferDate(props.plan.endTime)} (${props.plan.days}天)`,
        specialDesc: ''
      })
    }
    {RowItem({ name: '负责人', desc: props?.projectManager })}
    {RowItem({
      name: '电话', specialDesc: props?.personMobile, status: 'success', onClick: () => {
        window.location.href = `tel:${props?.personMobile}`;
      }
    })}
    {RowItem({ name: '公司', desc: props?.companyName })}
    {props?.type === AcceptStatus.PENDING ?
      <>
        <Divider style={{ margin: '5px 0' }} />
        <div className='button-wrapper'>
          <Button style={{ flex: 1, color: '#2a2a2a', border: '.5px solid #d5d5d5' }} onClick={() => { confirm(false) }}> 拒绝 </Button>
          <Button style={{ flex: 2 }} color="primary" fill="solid" onClick={() => { confirm(true) }}>
            接受
          </Button>
        </div>
      </> : null
    }
  </div>
}

const RenderRestTime = ({ dpStatus, rest, onRefresh }: any) => {
  const cancelRestTime = async () => {
    Dialog.show({
      content: CustomDialogContent({ content: '撤销后管理员在该时间段正常派工，确定要撤销吗？' }),
      closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: '我点错了',
            style: ACTION_STYLE.CANCEL,
            danger: true,
            onClick: () => {

            }
          },
          {
            key: 'confirm',
            text: '确定撤销',
            style: ACTION_STYLE.CONFIRM,
            onClick: async () => {
              const res = await CameraRpApi.cancelPersonDispatchRest({
                faceEntityId: dpStatus?.faceEntityId,
                rest: {
                  id: rest.id
                }
              })
              if (res.code === '200') {
                Toast.show({ content: '撤销成功', position: 'top' })
                onRefresh && onRefresh()
              }
            }
          },
        ],
      ],
    })
  }

  const [timeVisible, setTimeVisible] = useState(false)
  const onAddRestTime = async (timeRange: Date[]) => {
    const newTimeRange = timeRange.map(it => format(it, 'yyyy-MM-dd'))
    const res = await CameraRpApi.addPersonDispatchRest({
      faceEntityId: dpStatus?.faceEntityId,
      rest: {
        startTime: newTimeRange[0],
        endTime: newTimeRange[1],
      }
    })
    if (res.code === '200') {
      Toast.show({ content: '设置成功', position: 'top' })
      onRefresh && onRefresh()
    }
  }
  return <>
    <div className='sel-time-wrapper'>
      <div className='sel-time-top'>
        <span className='sel-time-top-left' style={{
          fontWeight: rest ? 600 : 400
        }}>休息时间段{rest ? ` (${getDuration(rest?.startTime, rest?.endTime) + '天'})` : '：未设置'}</span>
        <span onClick={() =>
          rest ? cancelRestTime() : setTimeVisible(true)} className='sel-time-top-right'>{rest ? '撤销' : '添加时间段'}</span>
      </div>
      {!!rest &&
        <>
          <Divider style={{ margin: '15px 0' }} />
          <div className='sel-time-info'>
            {transferDate(rest.startTime)} - {transferDate(rest.endTime)}
          </div>
        </>}
    </div>
    <CalendarPicker
      title={'选择休息时间段'}
      popupStyle={{ paddingTop: '20px' }}
      visible={timeVisible}
      selectionMode="range"
      defaultValue={rest ? [
        rest.startTIme,
        rest.endTIme
      ] : undefined}
      onClose={() => setTimeVisible(false)}
      onMaskClick={() => setTimeVisible(false)}
      onConfirm={(val) => {
        val && onAddRestTime(val)
      }}
    />
  </>
}

const RowItem = (props: any) => {
  const getStatus = (status: string) => {
    let color = undefined
    switch (status) {

      case 'ahead':
        if (props.type === 'exit') {
          color = '#2A2A2A'
        } else {
          color = '#36BE66'
        }
        break;
      case 'behind':
        color = '#FFB43D'
        break;
      case 'ok-behind':
        color = '#2A2A2A'
        break;
      case 'not-yet-started':
        color = '#FF6868'
        break;
      case 'success':
        color = '#00BFD1'
        break;
      case 'warn':
        color = '#FFB43D'
        break;
      case 'error':
        color = '#FF6868'
        break;
      default:
        break;
    }
    return color
  }
  return (
    <div className='row-wrapper'>
      <div className='row-name'>{props.name}</div>
      <div onClick={() => {
        props.onClick && props.onClick()
      }} className='row-desc'>{props.desc}
        {!!props.specialDesc && <span style={{
          color: getStatus(props?.status)
        }}>{props.specialDesc}</span>}
      </div>
    </div>
  )
}

const CustomDialogContent = (props: any) => {
  return <div style={{
    padding: '0 8px',
    textAlign: 'center',
    fontSize: '16px'
  }}>
    {props.content}
  </div>
}


function transferDate(date: string) {
  return date ? format(new Date(date), 'yyyy年MM月dd日') : ''
}

